// extracted by mini-css-extract-plugin
module.exports = {"product-footer":"style_product-footer__lC6-v","stock__text":"style_stock__text__2I9oV"};